import { useReactiveVar } from "@apollo/client";
import { Auth } from "common/Auth";
import { stateVar } from "common/Auth/Utils/state";
import { HydrationHelper } from "core/utils";
var RealAuthManager = /** @class */ (function () {
    function RealAuthManager() {
    }
    // eslint-disable-next-line class-methods-use-this
    RealAuthManager.prototype.use = function () {
        var state = useReactiveVar(stateVar);
        return HydrationHelper.useComplete() ? state : Auth.Status.pending();
    };
    return RealAuthManager;
}());
export { RealAuthManager };
